import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { EmptyCell, NameValueRecord, Typography } from 'shared/ui'
import type { ISendFromInfo } from 'entities/SendFrom'
import { type EnrollmentFilters } from 'widgets/ContactEnrollment'
import { EnrollmentPreview } from 'widgets/ContactEnrollment/ui/EnrollmentList'
import { useDetailsContext } from '../detailsContext'
import styles from './styles.module.scss'

export const TriggerTab = observer(() => {
  const { data, futureSendFrom, futureFutureContactsCount, futureEnrollmentFilters } =
    useDetailsContext()

  const [sendFrom, setSendFrom] = useState<ISendFromInfo | null>(null)
  const [contactsCount, setContactsCount] = useState<number | null>(null)
  const [enrollmentFilters, setEnrollmentFilters] = useState<EnrollmentFilters | null>(null)

  useEffect(() => {
    futureSendFrom.then(setSendFrom)
    futureFutureContactsCount.then(setContactsCount)
    futureEnrollmentFilters?.then(setEnrollmentFilters)
  }, [])

  const filtersSize = data.filters
    ? Object.values(data.filters).reduce((sum, arr) => sum + (arr?.length ?? 0), 0)
    : 0

  const runValue = filtersSize > 0 ? 'Manually, Automatically' : 'Manually'
  const reEnroll = data.settings?.allow_re_entering?.value

  return (
    <div className={styles.section}>
      <Typography variant={'body-lg-medium'} ariaLabel={'Trigger'}>
        Trigger
      </Typography>
      <div className={styles.sectionRows}>
        <div className={styles.sectionRow}>
          <Typography ariaLabel='Run' variant='text-input-field' className={styles.label}>
            Run
          </Typography>
          <Typography ariaLabel='RunValue' variant='body-md-regular' className={styles.value}>
            {runValue}
          </Typography>
        </div>
        <div className={styles.sectionRow}>
          <Typography
            ariaLabel='EnrolledContacts'
            variant='text-input-field'
            className={styles.label}
          >
            Enrolled contacts
          </Typography>
          <Typography
            ariaLabel='EnrolledContactsValue'
            variant='body-md-regular'
            className={styles.value}
          >
            {contactsCount !== null ? contactsCount.toLocaleString() : 0}
          </Typography>
        </div>
        {filtersSize > 0 && (
          <>
            <div className={styles.sectionRow}>
              <Typography
                ariaLabel='EnrollmentCriteria'
                variant='text-input-field'
                className={styles.label}
              >
                Enrollment criteria
              </Typography>
              <div className={styles.value}>
                {enrollmentFilters ? (
                  <div className={styles.enrollmentCriteria}>
                    <EnrollmentPreview filters={enrollmentFilters} />
                  </div>
                ) : (
                  <EmptyCell />
                )}
              </div>
            </div>
            <div className={styles.sectionRow}>
              <Typography ariaLabel='ReEnroll' variant='text-input-field' className={styles.label}>
                Re-enroll
              </Typography>
              <Typography
                ariaLabel='ReEnrollValue'
                variant='body-md-regular'
                className={styles.value}
              >
                {reEnroll ? 'ON' : 'OFF'}
              </Typography>
            </div>
          </>
        )}
        <div className={styles.sectionRow}>
          <Typography ariaLabel='SendFrom' variant='text-input-field' className={styles.label}>
            Send from
          </Typography>
          <div className={styles.value}>
            {sendFrom ? <NameValueRecord {...{ ...sendFrom, showIcon: false }} /> : <EmptyCell />}
          </div>
        </div>
      </div>
    </div>
  )
})
